import Hero from "../components/Hero"
import Slider from "../components/Slider"
import SliderLogos from "../components/SliderLogos"
import ExpedienteSection from "../components/Expediente"
import CardsHome from "../components/HomeCards"
import FormHomeMobile from "../components/FormHomeMobile"
import FormHome from "../components/FormHome"
import heroimg from "../assets/img/banners/home.png"
import Posts from "../components/Posts"

export default function Home() {

    return(
        <>
        <Hero img={heroimg} position="sticky" marginbtm="[20vh]" className="m-90" />
        <FormHome />
        <FormHomeMobile />
        <Slider />
        <ExpedienteSection />
        <SliderLogos />
        <CardsHome />
        <Posts />
        </>
    )
}